export default __webpack_public_path__ + "static/media/Masscopter.93856568.jpg";